import TextField from "@material-ui/core/TextField";
import { IconButton, InputAdornment, CircularProgress, Tooltip } from "@material-ui/core";
import { Visibility, VisibilityOff, Storage, Lock, Language, AccountCircle, InsertLink, LinkOff } from "@material-ui/icons";
import React from "react";
import styled, { keyframes } from "styled-components";

function TabONE({
	values,
	touched,
	errors,
	handleChange,
	onTestConnect,
	connected,
	isLoading
}) {
	const [passwordVisibility, setPasswordVisibility] = React.useState({
		login: false,
		password: false,
	});

	const togglePasswordVisibility = (field) => {
		setPasswordVisibility((prev) => ({
			...prev,
			[field]: !prev[field],
		}));
	};

	return (
		<ModernFormContainer>
			<SectionCard>
				<SectionHeader>
					<SectionIcon color="#e74c3c">
						<Storage />
					</SectionIcon>
					<SectionTitle>Configurações SAP Business One</SectionTitle>
					{onTestConnect && (
						<ConnectionButton
							onClick={onTestConnect}
							connected={connected}
							disabled={isLoading}
						>
							{isLoading ? (
								<CircularProgress size={18} style={{ color: 'white' }} />
							) : (
								<Tooltip title={connected ? "Conectado ao SAP" : "Testar conexão SAP"}>
									{connected ? <InsertLink /> : <LinkOff />}
								</Tooltip>
							)}
						</ConnectionButton>
					)}
				</SectionHeader>
				<FormGrid columns={2}>
					<StyledFieldContainer>
						<FieldLabel>
							<Storage style={{ fontSize: '18px', marginRight: '8px', color: '#9b59b6' }} />
							Banco de Dados SAP
						</FieldLabel>
						<TextField
							InputLabelProps={{ shrink: true }}
							fullWidth
							id="database"
							name="database"
							placeholder="Nome do banco de dados"
							value={values.database}
							onChange={handleChange}
							error={touched.database && Boolean(errors.database)}
							helperText={touched.database && errors.database}
							autoComplete="off"
							variant="outlined"
						/>
					</StyledFieldContainer>

					<StyledFieldContainer>
						<FieldLabel>
							<AccountCircle style={{ fontSize: '18px', marginRight: '8px', color: '#3498db' }} />
							Login SAP
						</FieldLabel>
						<TextField
							InputLabelProps={{ shrink: true }}
							fullWidth
							id="login"
							name="login"
							placeholder="Usuário do SAP"
							value={values.login}
							onChange={handleChange}
							error={touched.login && Boolean(errors.login)}
							helperText={touched.login && errors.login}
							autoComplete="off"
							variant="outlined"
							type={passwordVisibility.login ? "text" : "password"}
							InputProps={{
								endAdornment: (
									<InputAdornment position="end">
										<IconButton
											onClick={() => togglePasswordVisibility("login")}
											edge="end"
										>
											{passwordVisibility.login ? <VisibilityOff /> : <Visibility />}
										</IconButton>
									</InputAdornment>
								),
							}}
						/>
					</StyledFieldContainer>

					<StyledFieldContainer>
						<FieldLabel>
							<Lock style={{ fontSize: '18px', marginRight: '8px', color: '#e74c3c' }} />
							Senha SAP
						</FieldLabel>
						<TextField
							InputLabelProps={{ shrink: true }}
							fullWidth
							id="password"
							name="password"
							placeholder="Senha do SAP"
							value={values.password}
							onChange={handleChange}
							error={touched.password && Boolean(errors.password)}
							helperText={touched.password && errors.password}
							autoComplete="off"
							variant="outlined"
							type={passwordVisibility.password ? "text" : "password"}
							InputProps={{
								endAdornment: (
									<InputAdornment position="end">
										<IconButton
											onClick={() => togglePasswordVisibility("password")}
											edge="end"
										>
											{passwordVisibility.password ? <VisibilityOff /> : <Visibility />}
										</IconButton>
									</InputAdornment>
								),
							}}
						/>
					</StyledFieldContainer>

					<StyledFieldContainer>
						<FieldLabel>
							<Language style={{ fontSize: '18px', marginRight: '8px', color: '#16a085' }} />
							URL Service Layer SAP
						</FieldLabel>
						<TextField
							InputLabelProps={{ shrink: true }}
							fullWidth
							id="url"
							name="url"
							placeholder="https://servicelayer:port/b1s/v1"
							value={values.url}
							onChange={handleChange}
							error={touched.url && Boolean(errors.url)}
							helperText={touched.url && errors.url}
							autoComplete="off"
							variant="outlined"
						/>
					</StyledFieldContainer>
				</FormGrid>
			</SectionCard>
		</ModernFormContainer>
	);
}

export default TabONE;

// Animações
const fadeIn = keyframes`
	from {
		opacity: 0;
		transform: translateY(10px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
`;

const ModernFormContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
	font-family: 'Mulish', sans-serif;
`;

const SectionCard = styled.div`
	background: white;
	border-radius: 16px;
	padding: 24px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
	border: 1px solid #e8e8e8;
	animation: ${fadeIn} 0.5s ease;
	transition: all 0.3s ease;

	&:hover {
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
		border-color: #d0d0d0;
	}
`;

const SectionHeader = styled.div`
	display: flex;
	align-items: center;
	margin-bottom: 20px;
	padding-bottom: 16px;
	border-bottom: 2px solid #f0f0f0;
`;

const ConnectionButton = styled.button`
	margin-left: auto;
	border: none;
	border-radius: 50%;
	width: 36px;
	height: 36px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
	transition: all 0.3s ease;
	background: ${props => {
		if (props.disabled) return '#e0e0e0';
		return props.connected
			? 'linear-gradient(135deg, #27ae60 0%, #229954 100%)'
			: 'linear-gradient(135deg, #f39c12 0%, #e67e22 100%)';
	}};
	color: white;

	&:hover {
		transform: ${props => props.disabled ? 'none' : 'scale(1.1)'};
		box-shadow: ${props => {
			if (props.disabled) return 'none';
			return props.connected
				? '0 4px 12px rgba(39, 174, 96, 0.4)'
				: '0 4px 12px rgba(243, 156, 18, 0.4)';
		}};
	}

	svg {
		font-size: 20px;
	}
`;

const SectionIcon = styled.div`
	width: 40px;
	height: 40px;
	border-radius: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: ${props => props.color ? `${props.color}15` : '#667eea15'};
	color: ${props => props.color || '#667eea'};
	margin-right: 12px;
	transition: all 0.3s ease;

	svg {
		font-size: 22px;
	}

	${SectionCard}:hover & {
		transform: scale(1.1);
	}
`;

const SectionTitle = styled.h3`
	font-size: 18px;
	font-weight: 700;
	color: #2c3e50;
	margin: 0;
	font-family: 'Mulish', sans-serif;
`;

const FormGrid = styled.div`
	display: grid;
	grid-template-columns: ${props => props.columns === 2 ? 'repeat(2, 1fr)' : '1fr'};
	gap: 20px;

	@media (max-width: 768px) {
		grid-template-columns: 1fr;
	}
`;

const StyledFieldContainer = styled.div`
	display: flex;
	flex-direction: column;

	.MuiOutlinedInput-root {
		border-radius: 10px;
		transition: all 0.3s ease;

		&:hover {
			box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);
		}

		&.Mui-focused {
			box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
		}
	}

	.MuiInputLabel-outlined {
		font-family: 'Mulish', sans-serif;
		font-weight: 500;
	}

	.MuiOutlinedInput-input {
		font-family: 'Mulish', sans-serif;
	}
`;

const FieldLabel = styled.label`
	font-size: 14px;
	font-weight: 600;
	color: #2c3e50;
	margin-bottom: 8px;
	display: flex;
	align-items: center;
	font-family: 'Mulish', sans-serif;
`;
